var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isAccountReady
    ? _c("div", { staticClass: "go-content-wrapper gray" }, [
        _c("div", { staticClass: "go-container mypage" }, [
          _c("div", { staticClass: "go-layout-wrap" }, [
            _c("div", { staticClass: "go-page-header-type2" }, [
              _c("div", { staticClass: "go-page-title" }, [
                _vm._v(_vm._s(_vm.$t("myPage.common.myPage"))),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "go-layout-content" },
              [
                _vm.isGuest
                  ? _c("div", { staticClass: "go-panel go-panel-common" }, [
                      _c("div", { staticClass: "go-panel-header" }, [
                        _c("h3", [
                          _vm._v(_vm._s(_vm.$t("myPage.common.myAccount"))),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "go-panel-body" }, [
                        _c("div", { staticClass: "mypage-account login" }, [
                          _vm._m(0),
                          _vm._v(" "),
                          _c("div", { staticClass: "go-user-login" }, [
                            _c("p", [
                              _c("strong", [
                                _vm._v(
                                  _vm._s(_vm.$t("myPage.guest.requiredLogin"))
                                ),
                              ]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.$t("myPage.guest.description"))
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _c(
                                "button",
                                {
                                  staticClass: "btn go-btn-default",
                                  attrs: { type: "button" },
                                  on: { click: _vm.signUp },
                                },
                                [_vm._v(_vm._s(_vm.$t("myPage.button.signUp")))]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "btn go-btn-primary",
                                  attrs: { type: "button" },
                                  on: { click: _vm.signIn },
                                },
                                [_vm._v(_vm._s(_vm.$t("myPage.button.signIn")))]
                              ),
                            ]),
                          ]),
                        ]),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isGuest
                  ? _c("div", { staticClass: "go-panel go-panel-common" }, [
                      _c("div", { staticClass: "go-panel-header" }, [
                        _c("h3", [
                          _vm._v(_vm._s(_vm.$t("myPage.common.myAccount"))),
                        ]),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn go-btn-icon",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.goTo("/my-page/detail")
                              },
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "go-icon-24 go-icon-chevron-right",
                            }),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "go-panel-body" }, [
                        _c("div", { staticClass: "mypage-account" }, [
                          _c("div", { staticClass: "go-user-thumb" }, [
                            _c("img", {
                              attrs: {
                                id: "avatar",
                                src: _vm.getCurrentUserImageUri
                                  ? _vm.getCurrentUserImageUri
                                  : _vm.imageUrl,
                                alt: "",
                              },
                              on: { error: _vm.onErrorImageAvatar },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("ul", [
                            _c("li", [
                              _c("strong", [
                                _vm._v(_vm._s(_vm.account.lastName)),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("li", [
                              _c("i", {
                                staticClass: "go-icon-24 go-icon-device-mobile",
                              }),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm.account.phoneNumber
                                        ? _vm.formatPhoneNumberToE164(
                                            _vm.account.phoneNumber,
                                            _vm.account.phoneCountry
                                          )
                                        : _vm.$t("myPage.pleaseRegisterPhone")
                                    ) +
                                    "\n                  "
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("li", [
                              _c("i", {
                                staticClass: "go-icon-24 go-icon-mail",
                              }),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(
                                  _vm._s(
                                    _vm.account.email
                                      ? _vm.account.email
                                      : _vm.$t("myPage.pleaseRegisterEmail")
                                  )
                                ),
                              ]),
                            ]),
                          ]),
                        ]),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("user-paid-info", { attrs: { "is-guest": _vm.isGuest } }),
                _vm._v(" "),
                !_vm.isGuest ? _c("user-scrap-agent") : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "go-panel go-panel-common" }, [
                  _c("div", { staticClass: "go-panel-header" }, [
                    _c("h3", [_vm._v(_vm._s(_vm.$t("myPage.common.setting")))]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn go-btn-icon",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.goTo("/my-page/setting")
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "go-icon-24 go-icon-chevron-right",
                        }),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "go-panel-body" }, [
                    _c("div", { staticClass: "mypage-nav" }, [
                      _c("dl", [
                        _c("dt", [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.$t("myPage.common.theme"))),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("dd", [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t(_vm.theme) || "Light")),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("dl", [
                        _c("dt", [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.$t("myPage.common.language"))),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("dd", [
                          _c("span", [_vm._v(_vm._s(_vm.$t(_vm.language)))]),
                        ]),
                        _vm._v(" "),
                        _c("dt", [
                          _c("strong", [
                            _vm._v(
                              _vm._s(_vm.$t("myPage.common.referLanguage"))
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("dd", [
                          _c("span", [_vm._v(_vm._s(_vm.contentLanguage))]),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
              ],
              1
            ),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "go-user-thumb" }, [
      _c("img", {
        attrs: {
          src: "content/images/images_v4/common/go-empty-profile-sz96.png",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }